import { render, staticRenderFns } from "./CartIcon24px.vue?vue&type=template&id=95f5e716&"
import script from "./CartIcon24px.vue?vue&type=script&lang=ts&"
export * from "./CartIcon24px.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports